/**
 * Devuelve una función que permite recuperar el texto de una <option> pasandole su valor.
 *
 * @param {object} viewProperties el properties del campo en el view, todos los hijos del 'tree'
 * @returns
 */
export function getSelectTextFactory(viewProperties) {
  const selects = createSelects();

  /**
   * Devuelve el 'texto' correspondiente al 'valor' de una option de un campo de tipo select
   *
   * @param {string} path el modelo/path del campo
   * @param {string|number} value el valor del <option>
   * @returns
   */
  return function getSelectText(path, value) {
    if (!selects[path]) {
      return value;
    }
    try {
      return selects[path][value] || value;
    } catch (e) {
      return value || '';
    }
  };

  /**
   * Recorre todos los campos del properties y para cada uno de tipo select,
   * registra un clave:valor de las option value:text
   *
   * @returns {object}
   */
  function createSelects() {
    const res = {};
    handleProperties(viewProperties);

    /**
     * Function que recorre las properties del view recursivamente para los select
     * @param {object} properties
     */
    function handleProperties(properties) {
      properties.forEach(property => {
        if (property.type === 'select') {
          const options =
            property.metadata.select ||
            property.metadata.options.reduce((acc, { value, text }) => {
              acc[value] = text;
              return acc;
            }, {});
          res[property.model] = options;
        }
        property.properties && handleProperties(property.properties);
      });
    }
    return res;
  }
}
